import React from "react";
import { MdLabelImportant } from "react-icons/md";

const HowToPlay = () => {
  return (
    <div className="select-none flex justify-center items-center h-screen">
      <div className="border-4 border-theme-5 p-3.5 lg:w-1/3 md:w-1/2 w-5/6">
        <div className=" text-theme-2 flex justify-center items-center mb-2">
        <MdLabelImportant className="text-2xl pb-[2px]" />
        <h1 className="text-center font-mono font-bold text-xl">Dot Connect</h1>
        </div>
        <p className="font-semibold text-theme-8 text-center">
          It is an engaging and strategic two-player game
          where the goal is to complete more boxes than your opponent by drawing
          <span className="font-bold text-theme-1"> [click]</span> lines between adjacent dots on a grid. Players take turns drawing
          either horizontal or vertical lines, and when a player completes the
          fourth side of a box, they claim it and earn an extra turn. The game
          continues until all boxes are claimed, with the player having the most
          boxes declared the winner.
        </p>
      </div>
    </div>
  );
};

export default HowToPlay;
